import React from 'react';
import { Provider } from "react-redux";

import CryptoJS from 'crypto-js';

import configure from "../../store/configure";
import JoinInfoContainer from "./container/JoinInfoContainer";

const JoinInfoPage = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const oState = searchParams.get("oState");
    const jToken = searchParams.get("jToken");
    const tMms = searchParams.get("tMms");
    const tMail = searchParams.get("tMail");
    const tKakao = searchParams.get("tKakao");
    const hToken = searchParams.get('hToken');
    let hstate = searchParams.get('hstate');

    // 호스팅 상태값 파라미터가 없는 경우 세션 스토리지까지 확인 - 25.04.04 jisung
    if(!hstate) hstate = sessionStorage.getItem("hstate");

    let encryptedHstate = hstate;
    if(hstate) {
        hstate = hstate.replace(/ /g, '+');
        const decryptedBytes = CryptoJS.AES.decrypt(decodeURIComponent(hstate), process.env.REACT_APP_AES_ENCRYPT_KEY);
        hstate = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
    }

    return (
        <Provider store={configure}>
            <JoinInfoContainer
                oState={oState}
                jToken={jToken}
                tMms={tMms}
                tMail={tMail}
                tKakao={tKakao}
                encryptedHstate={encryptedHstate}
                hstate={hstate}
                hToken={hToken}
            />
        </Provider>
    )
};

export default JoinInfoPage;
